import * as z from 'zod'
import {buildEntrySchemaFor} from '@github-ui/swp-core/schemas/contentful/entry'
import {RichTextSchema} from '@github-ui/swp-core/schemas/contentful/richText'
import {safeOptional} from '@github-ui/swp-core/schemas/safe-optional'
import {LinkSchema} from './link'

export const PricingPlanSchema = buildEntrySchemaFor('pricingPlan', {
  fields: z.lazy(() =>
    z.object({
      title: z.string().optional(),
      heading: RichTextSchema,
      description: RichTextSchema,
      price: z.number(),
      originalPrice: safeOptional(z.string()),
      priceTrailing: safeOptional(z.string()),
      features: safeOptional(z.array(z.string())),
      trailingText: safeOptional(RichTextSchema),
      primaryCta: safeOptional(LinkSchema),
      secondaryCta: safeOptional(LinkSchema),
    }),
  ),
})

export type PricingPlan = z.infer<typeof PricingPlanSchema>
